<template>
  <span class="help-block" v-if="field && field.$error" >
      <span v-bind:key="index" v-for="(item, index) in errorMessages">
        <br v-if="index > 0"/>{{ item }}
      </span>
  </span>
</template>

<script>

import { each } from 'lodash'

export default {
  name: 'help-block',

  props: {
    field: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    customMessages: {
      type: Object,
      required: false
    }
  },

  computed: {
    errorMessages () {
      const messages = []
      if (this.field) {
        each(this.field.$params, (param, key) => {
          if (this.field[key] === false) {
            const switchValue = param && param.type ? param.type : key
            if (this.customMessages && this.customMessages[switchValue]) {
              messages.push(this.customMessages[switchValue])
            } else {
              switch (switchValue) {
                case 'required':
                case 'requiredIf':
                case 'requiredUnless':
                  messages.push(this.label + ' is required.')
                  break
                case 'sameAs':
                  messages.push(this.label + ' does not match.')
                  break
                case 'numeric':
                  messages.push(this.label + ' needs to be a number.')
                  break
                case 'between':
                  messages.push(this.label + ` needs to be a number between ${param.min} and ${param.max}.`)
                  break
                case 'multipleEmails':
                  messages.push(`Each entry must be a valid email address, separated by ';'`)
                  break
                case 'lessThanBudget':
                  messages.push(`Value must be less than budget`)
                  break
                case 'notBudget':
                  messages.push(`You cannot reference the budget`)
                  break
                case 'notEmail':
                  messages.push(`You cannot provide an email`)
                  break
                case 'notPhone':
                  messages.push(`You cannot provide a phone number`)
                  break
                case 'phoneValid':
                case 'phoneNumber':
                  messages.push(this.label + ` is not a valid phone number`)
                  break
                case 'insideDateBounds':
                  messages.push(`These dates are not within the correct bounds.`)
                  break
                case 'isAfterDate':
                  messages.push(this.label + ` must be after the start date`)
                  break
                default:
                  messages.push(this.label + ' is not valid')
              }
            }
          } else if (this.field[key] === false && param === null) {
            messages.push(this.label + ' is not valid')
          }
        })
      }
      return messages
    }
  }
}
</script>
